import type {SxProps, Theme} from '@mui/material';

export const commonStyles = {
    hoverStyles: {
        backgroundColor: "transparent",
        "& .MuiTypography-root": {
            color: (theme: Theme) => theme.palette.primary.main
        },
        "& .MuiSvgIcon-root": {
            color: (theme: Theme) => theme.palette.primary.main
        }
    },

    activeStyles: (isActive: boolean, isFirstLevel: boolean = false,
                   hasChildren: boolean = true, isEasyLangMode: boolean = false): SxProps<Theme> =>
        isActive ? (
            isFirstLevel && !hasChildren ? {
                backgroundColor: isEasyLangMode ? (theme: Theme) => theme.palette.primary.main : "transparent",
                "& .MuiTypography-root": {
                    color: isEasyLangMode ? 'white' : (theme: Theme) => theme.palette.primary.dark
                },
                ...(isEasyLangMode ? {
                    "&:hover": {
                        backgroundColor: (theme: Theme) => theme.palette.primary.dark,
                        color: 'white'
                    }
                } : {
                    "&:hover": {
                        backgroundColor: "transparent",
                        borderTop: (theme: Theme) => `1px solid ${theme.palette.divider}`,
                        borderBottom: (theme: Theme) => `1px solid ${theme.palette.divider}`,
                        "& .MuiTypography-root": {
                            color: (theme: Theme) => theme.palette.primary.main
                        },
                        "& .MuiSvgIcon-root": {
                            color: (theme: Theme) => theme.palette.primary.main
                        }
                    }
                })
            } : {
                backgroundColor: (theme: Theme) => theme.palette.primary.main,
                color: (theme: Theme) => theme.palette.primary.contrastText,
                borderTop: "1px solid transparent",
                borderBottom: "1px solid transparent",
                "& .MuiTypography-root": {
                    color: (theme: Theme) => theme.palette.primary.contrastText
                },
                "&:hover": {
                    backgroundColor: (theme: Theme) => theme.palette.primary.main,
                    borderTop: (theme: Theme) => `1px solid ${theme.palette.divider}`,
                    borderBottom: (theme: Theme) => `1px solid ${theme.palette.divider}`,
                    "& .MuiTypography-root": {
                        color: (theme: Theme) => theme.palette.primary.contrastText
                    },
                    "& .MuiSvgIcon-root": {
                        color: (theme: Theme) => theme.palette.primary.contrastText
                    }
                }
            }
        ) : {},

    menuItemLayout: {
        display: "flex",
        alignItems: "center",
        padding: "0 12px !important",
        justifyContent: "space-between",
    },

    menuItemTypographyProps: (fontSize?: string) => ({
        variant: "navigationItem" as const,
        sx: {
            fontWeight: 500,
            ...(fontSize && {fontSize}),
            my: 0
        }
    })
};
